import GearIcon from './component.jsx'
export default GearIcon
